<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="12.177" height="15.402" viewBox="0 0 12.177 15.402">
		<path
			id="Path_30438"
			data-name="Path 30438"
			d="M15.034,10.742V8.861a2.418,2.418,0,0,0-2.418-2.418H11.541a.806.806,0,0,1-.806-.806V4.561A2.418,2.418,0,0,0,8.316,2.143H6.973m0,9.136h5.374m-5.374,2.15H9.66M8.585,2.143H5.092a.806.806,0,0,0-.806.806V15.31a.806.806,0,0,0,.806.806h9.136a.806.806,0,0,0,.806-.806V8.592A6.449,6.449,0,0,0,8.585,2.143Z"
			transform="translate(-3.571 -1.429)"
			fill="none"
			stroke="#5a677d"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.429"
		/>
	</svg>
</template>

<script>
export default {
	name: 'DocSvg',
};
</script>

<style scoped lang="scss"></style>
